import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

import { Report } from 'services/action';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  Skeletons,
  SkeletonPageFooter,
} from 'ui/components/skeleton';
import useTable from 'ui/components/table';

import tableConfig from './component/table/config';
import Filter from './component/table/filter';
import { currencyFormat } from 'utilities/common';

const initialState = {
  displayFilter: false,
  count: [],
  summary: null
};

const ReportReceivableScreen = () => {
  const Dispatch = useDispatch();
  const ConfigTable = useTable('report_receivable', tableConfig);
  const StateTable = useSelector((state) => state?.Table?.data['report_receivable']);

  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ displayFilter, count, summary }, setState] = React.useState(initialState);

  const $loadSummary = async (e) => {
    const result = await Dispatch(Report.$receivableSummary(StateTable?.filter));
    if (result?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        summary: result?.data
      }));
    }
  };

  React.useEffect(() => {
    if (!StateLoading) {
      $loadSummary();
    }

  }, [StateLoading]);

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle="Daftar"
        className="bg-white"
        title={'Laporan Receivable'}
        isLoading={StateLoading}
      />

      <div className="row p-2 justify-content-center">
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(summary?.subtotal_nett || 0)}
            </div>
            <div className="page-pretitle text-secondary">DPP</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(summary?.subtotal_tax || 0)}
            </div>
            <div className="page-pretitle text-primary">PPN</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(summary?.subtotal_charges + summary?.subtotal_pph || 0)}
            </div>
            <div className="page-pretitle text-warning">Total Harga</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {summary?.subtotal_pph > 0 ? `(${currencyFormat(summary?.subtotal_pph || 0)})`: 0}
            </div>
            <div className="page-pretitle text-primary">PPH</div>
          </div>
        </div>
      </div>
      <div className="row p-2 justify-content-center">
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(summary?.subtotal_charges || 0)}
            </div>
            <div className="page-pretitle ">Receivable</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(summary?.subtotal_paid || 0)}
            </div>
            <div className="page-pretitle text-success">Payment</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(summary?.subtotal_additional_charges || 0)}
            </div>
            <div className="page-pretitle text-warning">Admin/Return</div>
          </div>
        </div>
      </div>

      <Page.Navigation toolbar>
        <ConfigTable.Tools downloadable isLoading={StateLoading}>
          {StateLoading ? (
            <div className="ms-2">
              <Skeletons height="35px" width="50px" />
            </div>
          ) : (
            <Button
              variant={displayFilter ? 'primary' : 'secondary'}
              className="ms-2 position-relative"
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  displayFilter: !displayFilter,
                }))
              }
            >
              <Fi.FiFilter size={19} color="white" />
              {count?.length > 0 ? (
                <span className="position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger">
                  {count?.length}
                </span>
              ) : null}
            </Button>
          )}
        </ConfigTable.Tools>
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div
          className={cn(
            displayFilter ? 'col-md-9  m-0 p-0' : 'col-md-12   m-0 p-0'
          )}
        >
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <ConfigTable.Render />
          )}
        </div>

        <Filter
          ConfigTable={ConfigTable}
          onClose={() =>
            setState((prevState) => ({
              ...prevState,
              displayFilter: false,
            }))
          }
          show={displayFilter}
          setCount={(x) =>
            setState((prevState) => ({
              ...prevState,
              count: x,
            }))
          }
        />
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <ConfigTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default ReportReceivableScreen;
